module.exports = __webpack_public_path__ + "static/media/img_mapa.8fce0b38.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/central_fert/img_mapa.png
// module id = 468
// module chunks = 3